import i18n from './../../i18n';

const app = {
  state: {
    user: null,
    userGroup: [],
    empresa: null,
    empresas: [],
    suscripcion: null,
    drawer: localStorage.getItem('drawerStatus')
      ? !!+localStorage.getItem('drawerStatus')
      : true,
    language: localStorage.getItem('language') || 'es',
    busy: false,
    busyText: 'Cargando...',
    misCpcs: []
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.drawer = !state.drawer;
      if (state.drawer) {
        localStorage.setItem('drawerStatus', 1);
      } else {
        localStorage.setItem('drawerStatus', 0);
      }
    },
    CLOSE_SIDEBAR: state => {
      localStorage.setItem('drawerStatus', 0);
      // Cache.setItem("drawerStatus", 0);
      state.drawer = false;
    },
    colapsed(state) {
      state.drawer = !state.drawer;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_USER_GROUP(state, value) {
      state.userGroup = value;
    },
    SET_EMPRESA(state, empresa) {
      state.empresa = empresa;
      state.empresas = [];
      state.empresas.push({
        label: empresa.razonSocial,
        value: empresa.ruc
      });
      console.log(empresa);
      console.log(state.empresas);
    },
    SET_SUSCRIPCION(state, suscripcion) {
      state.suscripcion = suscripcion;
    },
    SET_USER_ATTRIBUTES(state, attributes) {
      state.user.attributes = attributes;
    },
    SET_LANGUAGE: (state, language) => {
      console.log('SET_LANGUAGE');
      localStorage.setItem('language', language);
      i18n.locale = language;
      state.language = language;
    },
    SET_MIS_CPCS: (state, cpcs) => {
      console.log('SET_MIS_CPCS');
      state.misCpcs = cpcs;
    },
    SET_BUSY_INDICATOR: state => {
      state.busy = !state.busy;
    },
    SET_BUSY_TEXT: (state, busyText) => {
      state.busyText = busyText;
    }
  },
  actions: {
    setUser({ commit }, user) {
      console.log('action: setUser', user);
      commit('SET_USER', user);
    },
    setUserGroup({ commit }, UserGroup) {
      console.log('action: setUserGroup', UserGroup);
      commit('SET_USER_GROUP', UserGroup);
    },
    setEmpresa({ commit }, empresa) {
      console.log('action: setEmpresa', empresa);
      commit('SET_EMPRESA', empresa);
    },
    setSuscripcion({ commit }, suscripcion) {
      console.log('action: setSuscripcion', suscripcion);
      commit('SET_SUSCRIPCION', suscripcion);
    },
    setUserAttributes({ commit }, attributes) {
      commit('SET_USER_ATTRIBUTES', attributes);
    },
    toggleSideBar({ commit }) {
      console.log('action: toggleSideBar');
      commit('TOGGLE_SIDEBAR');
    },
    closeSideBar({ commit }) {
      commit('CLOSE_SIDEBAR');
    },
    setLanguage({ commit }, language) {
      console.log('Set language action', language);
      commit('SET_LANGUAGE', language);
    },
    setMisCpcs({ commit }, cpcs) {
      console.log('Set misCpcs action', cpcs);
      commit('SET_MIS_CPCS', cpcs);
    },
    setBusyIndicator({ commit }, [busy, busyText]) {
      commit('SET_BUSY_INDICATOR', busy);
      commit('SET_BUSY_TEXT', busyText);
    }
  }
};

export default app;
